module.exports = __webpack_public_path__ + "img/icon_service_info_total_1.6ce5c3d9.png";